import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24e4a5b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-col my-0" }
const _hoisted_2 = { class: "absolute top-0 bottom-0 left-0 right-0 z-10 flex items-end justify-center w-full h-full p-5 space-x-5 img-overlay" }
const _hoisted_3 = {
  key: 1,
  class: "absolute top-2.5 right-5 flex gap-x-1"
}

import ScorecardImageCardStatus from '@/components/Scorecard/ScorecardImageCardStatus.vue';
import { useUserStore } from '@/store/users';
import { Scorecard, ScorecardStatus } from '@/typings/scorecard';
import { computed, inject, PropType, Ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import Image from '@/components/Scorecard/Image.vue';
import { useScorecardStore } from '@/store/scorecards';
import { AlertModal, PromptModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  props: {
  scorecard: {
    type: Object as PropType<Scorecard>,
    required: true,
  },
  fixable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const router = useRouter();

const { scorecard } = toRefs(props);

const actionText = computed((): string => {
  if (scorecard.value.Status === ScorecardStatus.Locked) {
    return 'View Live Results';
  }
  if (
    [ScorecardStatus.Closed, ScorecardStatus.Finalizing].includes(
      scorecard.value.Status
    )
  ) {
    return 'View Results';
  }
  if (scorecard.value.Status === ScorecardStatus.Scheduled) {
    return 'View Preview';
  }
  return 'Edit Predictions';
});

const isActive = computed((): boolean =>
  ['Open', 'Locked', 'Closed', 'Finalising'].includes(scorecard.value.Status)
);

const userStore = useUserStore();

const isAdmin = computed((): boolean => userStore.user?.PrivilegeId === 1);

function openCard() {
  router.push(`/card/${scorecard.value.Slug}`);
}

const scorecardStore = useScorecardStore();

const promptModal = inject('promptModal') as Ref<PromptModal>;
const alertModal = inject('alertModal') as Ref<AlertModal>;

async function deleteCard() {
  const doDelete = await promptModal.value.show(
    `Remove the ${scorecard.value.Title} card?`,
    `You are about to delete the scorecard for ${scorecard.value.Title}. Once it has been removed, it cannot be recovered. Are you sure you want to delete it?`
  );
  if (doDelete) {
    await scorecardStore.deleteScorecard(scorecard.value);
    alertModal.value.show(
      'Card deleted',
      `The scorecard for ${scorecard.value.Title} has been removed.`
    );
  }
}

function editCard() {
  router.push(`/card/editor/${scorecard.value.Slug}`);
}

function editResults() {
  router.push(`/card/results/${scorecard.value.Slug}`);
}

function fix() {
  scorecardStore.fix(scorecard.value);
}

const $socket = inject('$socket');
$socket.on(
  'scorecard-status',
  ({ status, slug }: { status: string; slug: string }) => {
    if (slug === scorecard.value.Slug) {
      scorecard.value.Status =
        ScorecardStatus[status as keyof typeof ScorecardStatus];
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Image, { scorecard: _unref(scorecard) }, null, 8, ["scorecard"]),
    _createElementVNode("div", _hoisted_2, [
      (!['Locked', 'Closed'].includes(_unref(scorecard).Status))
        ? (_openBlock(), _createBlock(ScorecardImageCardStatus, {
            key: 0,
            class: "absolute top-2.5 left-5",
            scorecard: _unref(scorecard)
          }, null, 8, ["scorecard"]))
        : _createCommentVNode("", true),
      (_unref(isAdmin))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Button, {
              label: "Edit",
              onClick: editCard
            }),
            _createVNode(_component_Button, {
              label: "X",
              onClick: deleteCard
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(isActive) || _unref(isAdmin))
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            label: _unref(actionText),
            onClick: openCard
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (_unref(isAdmin))
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 3,
            label: "Submit Results",
            onClick: editResults
          }))
        : _createCommentVNode("", true),
      (__props.fixable)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 4,
            label: "Fix Championships",
            onClick: fix
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})